import React from "react"
import Cursor from "../../../components/Cursor"
import { render } from "storyblok-rich-text-react-renderer"

const TextWithCursor = (props) => {

    const blok = props.blok

    return(
        <section className={`width ${blok.pad_top ? `mt-mobile-menu lg:mt-desktop-menu pb-8 lg:pb-9 pt-0 lg:pt-20` : `py-8 lg:py-9`}`}>
            <p className={`font-serif cursor-text font-extralight ${blok.larger_text ? `large` : ``}`}>
                {blok.copy} {blok.hide_cursor ? null : <Cursor/>}
            </p>
        </section>
    )
}

export default TextWithCursor